export default __webpack_public_path__ + "static/media/3.b19df8a3.png";